module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/number_order_index-64584bf4103dca42f17330754c389363.png";